/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as actions from './BillingAddress-Actions';

const billingAddressInit = {
    firstName: '',
    lastName: '',
    address1: '',
    address2: '',
    address3: '',
    addressId: '',
    city: '',
    defaultBilling: false,
    email: '',
    confirmEmail: '',
    country: '',
    locationType: '',
    organizationName: '',
    phone: '',
    mobilePhone: '',
    state: '',
    zipCode: '',
    cityArray: [],
    isFormValid: false,
    isFormAutoFilled: false,
    checkSameAsDeliveryAddress: false,
    isRememberMe: true,
};

const billingAddressReducer = (state = billingAddressInit, action) => {
    switch (action.type) {
        case actions.updateBillingAddressForm().type:
            return {
                ...state,
                ...action.data,
                country: action.data?.country || 'US',
            };
        case actions.updateBillingAddressFormByName().type: {
            const formEvent = action.data;
            return { ...state, [formEvent.target.name]: formEvent.target.value };
        }
        case actions.billingAddressClearForm().type:
            return { ...billingAddressInit };
        case actions.billingAddressIsFormValid().type:
            return { ...state, isFormValid: action.data };
        case actions.billingAddressIsFormAutoFilled().type:
            return { ...state, isFormAutoFilled: action.data };
        case actions.billingAddressSetAsDefault().type:
            return { ...state, defaultBilling: action.data };
        case actions.billingAddressCheckSameAsDeliveryAddress().type:
            return { ...state, checkSameAsDeliveryAddress: action.data };
        default:
            return state;
    }
};

export default billingAddressReducer;
